import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_get_reason_code_by_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { reasonCodeId: number }): 
  Promise<{ result: { Id?: number, EnumName?: string, Label?: string, LookupCode?: string, Name?: string, NumberOfMinutesBeforeExpiration?: number, ParentEntity?: string, ParentId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.reasonCodeId)) {
      missingRequiredInParams.push('\'reasonCodeId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_get_reason_code_by_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      reasonCodeId: number    }) {
        if(isNil(inParams.reasonCodeId)) {
          return true; 
        }
      return false;
    }
}
